import React, { useEffect, useState } from 'react';
import './Vendors.css';
import { showError } from '../utils/sweetAlertHelper';

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [vendorUsers, setVendorUsers] = useState({});
  const [expandedVendor, setExpandedVendor] = useState(null);
  const [allUsers, setAllUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setCurrentUser(parsed);
        if (parsed.role === 'vendor') {
          fetchVendorUsers(parsed._id);
          setLoading(false);
          return;
        }
      } catch (e) {
        // ignore
      }
    }

    const token = localStorage.getItem('token');
    const base = process.env.REACT_APP_API_URL;

    fetch(`${base}/auth/vendors`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(async (res) => {
        const ct = res.headers.get('content-type') || '';
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || 'Failed to fetch vendors');
        }
        if (!ct.includes('application/json')) {
          const text = await res.text();
          throw new Error('Expected JSON but received HTML (check API base URL)');
        }
        return res.json();
      })
      .then((data) => setVendors(data.vendors || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  async function fetchVendorUsers(vendorId) {
    const token = localStorage.getItem('token');
    const base = process.env.REACT_APP_API_URL;

    try {
      const res = await fetch(`${base}/auth/vendors/${vendorId}/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setVendorUsers((prev) => ({ ...prev, [vendorId]: data.users || [] }));
      setAllUsers(data.users || []);
    } catch (err) {
      showError(err.message || 'Failed to fetch vendor users');
    }
  }

  async function toggleVendorUsers(vendorId) {
    if (expandedVendor === vendorId) {
      setExpandedVendor(null);
      return;
    }

    if (!vendorUsers[vendorId]) {
      const token = localStorage.getItem('token');
      const base = process.env.REACT_APP_API_URL;

      try {
        const res = await fetch(`${base}/auth/vendors/${vendorId}/users`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        setVendorUsers((prev) => ({ ...prev, [vendorId]: data.users || [] }));
      } catch (err) {
        showError(err.message || 'Failed to fetch vendor users');
        return;
      }
    }

    setExpandedVendor(vendorId);
  }

  if (loading) return <div>Loading vendors...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  if (currentUser?.role === 'vendor') {
    return (
      <div className="vendors-page">
        <div className="vendors-header">
          <h2 className="vendors-title">Users</h2>
        </div>

        <div className="table-container">
          <table className="lead-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {(vendorUsers[currentUser._id] || []).map((u) => (
                <tr key={u._id}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.status || 'active'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="vendors-page">
      <div className="vendors-header">
        <h2 className="vendors-title">Vendors</h2>
      </div>

      <div className="table-container">
        <table className="lead-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {vendors.map((v) => (
              <tr key={v._id}>
                <td>{v.name}</td>
                <td>{v.email}</td>
                <td>{v.status || 'active'}</td>
                <td>
                  <button className="btn" onClick={() => toggleVendorUsers(v._id)}>
                    {expandedVendor === v._id ? 'Hide Users' : 'Show Users'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {expandedVendor && vendorUsers[expandedVendor] && (
        <div className="table-container" style={{ marginTop: 12 }}>
          <h3 style={{ margin: '8px 0' }}>Users for Vendor</h3>
          <table className="lead-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {vendorUsers[expandedVendor].map((u) => (
                <tr key={u._id}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.status || 'active'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Vendors;